export const getCountsAllSites = sites => {
  const countsMap = {
    groupsThatHaventCompletedLesson: 0,
    smallGroupsCreated: 0,
    lessonsCompleted: 0,
  }

  if (!Array.isArray(sites)) {
    return countsMap
  }

  sites.forEach(site => {
    countsMap.groupsThatHaventCompletedLesson +=
      site.groupsThatHaventCompletedLesson || 0
    countsMap.smallGroupsCreated += site.smallGroupsCreated || 0
    countsMap.lessonsCompleted += site.lessonsCompleted || 0
  })

  return countsMap
}

/**
 * Determines if pagination is needed based on data length and page size
 * @param {Array} data - The data array to check
 * @param {number} pageSize - The number of items per page
 * @returns {boolean} True if pagination is needed
 */
export const shouldShowPagination = (data, pageSize) => {
  return !!(data && Array.isArray(data) && data.length > pageSize)
}

/**
 * Calculates pagination values for display
 * @param {Object} params - Pagination calculation parameters
 * @param {number} params.totalItems - Total number of items
 * @param {number} params.currentPage - Current page number (1-indexed)
 * @param {number} params.pageSize - Number of items per page
 * @param {number} params.paginatedItemsLength - Length of current page's items
 * @returns {Object} Pagination values including totalPages, siteStartCount, siteEndCount
 */
export const calculatePaginationValues = ({
  totalItems,
  currentPage,
  pageSize,
  paginatedItemsLength,
}) => {
  const totalPages = pageSize
    ? Math.max(1, Math.ceil(totalItems / pageSize))
    : 1

  const siteStartIndex = (currentPage - 1) * pageSize
  const siteStartCount = totalItems > 0 ? siteStartIndex + 1 : 0
  const siteEndCount = Math.min(
    siteStartIndex + (paginatedItemsLength || 0),
    totalItems,
  )

  return {
    totalPages,
    siteStartCount,
    siteEndCount,
  }
}

// Transform gradeBandData to format expected by AdminDonutChart
export const transformGradeBandForDonutChart = gradeBand => {
  if (!gradeBand) {
    return null
  }
  // Always render donuts, even with zero values - use defaults if lessonsCompletedByUnit is missing
  const lessonsCompletedByUnit = gradeBand.lessonsCompletedByUnit || {}

  return {
    unit1LessonsCompleted: lessonsCompletedByUnit['1'] || 0,
    unit2LessonsCompleted: lessonsCompletedByUnit['2'] || 0,
    unit3LessonsCompleted: lessonsCompletedByUnit['3'] || 0,
    lessonsCompleted: gradeBand.lessonsCompleted || 0,
    groupsCount: gradeBand.groupsCount || 0,
    totalUsers: gradeBand.groupsCount || 0, // Using groupsCount as totalUsers for compatibility
    gradeBand: gradeBand.gradeBand, // Pass through gradeBand name for use downstream
  }
}
